'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Project {
  id: string;
  name: string;
  tagline: string;
  description: string;
  type: string;
  status: string;
  statusColor: string;
  tech: string[];
  metrics: {label: string;value: string;}[];
  accentColor: string;
  image: string;
  imageAlt: string;
  github: string;
  live: string;
}

const PROJECTS: Project[] = [
{
  id: 'PRJ-001',
  name: 'Project 1',
  tagline: 'LOREM IPSUM DOLOR SIT AMET',
  description:
  'LOREM IPSUM DOLOR SIT AMET, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  type: 'SYSTEMS',
  status: 'DEPLOYED',
  statusColor: 'var(--cyber-green)',
  tech: ['Tech1', 'Tech2', 'Tech5', 'Tech3', 'Tech4'],
  metrics: [
  { label: 'LATENCY', value: '<10ms' },
  { label: 'JOBS/SEC', value: '50k+' },
  { label: 'UPTIME', value: '99.98%' }],

  accentColor: 'var(--cyber-cyan)',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1039b119c-1772163746686.png",
  imageAlt: 'Dark terminal screen with glowing blue code and network topology visualization',
  github: '#',
  live: '#'
},
{
  id: 'PRJ-002',
  name: 'Project 2',
  tagline: 'LOREM IPSUM DOLOR SIT AMET',
  description:
  'LOREM IPSUM DOLOR SIT AMET, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  type: 'SYSTEMS',
  status: 'DEPLOYED',
  statusColor: 'var(--cyber-green)',
  tech: ['Tech1', 'Tech2', 'Tech5', 'Tech3', 'Tech4'],
  metrics: [
  { label: 'LATENCY', value: '<10ms' },
  { label: 'JOBS/SEC', value: '50k+' },
  { label: 'UPTIME', value: '99.98%' }],

  accentColor: 'var(--cyber-cyan)',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1039b119c-1772163746686.png",
  imageAlt: 'Dark terminal screen with glowing blue code and network topology visualization',
  github: '#',
  live: '#'
},
{
  id: 'PRJ-003',
  name: 'Project 3',
  tagline: 'LOREM IPSUM DOLOR SIT AMET',
  description:
  'LOREM IPSUM DOLOR SIT AMET, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  type: 'SYSTEMS',
  status: 'DEPLOYED',
  statusColor: 'var(--cyber-green)',
  tech: ['Tech1', 'Tech2', 'Tech5', 'Tech3', 'Tech4'],
  metrics: [
  { label: 'LATENCY', value: '<10ms' },
  { label: 'JOBS/SEC', value: '50k+' },
  { label: 'UPTIME', value: '99.98%' }],

  accentColor: 'var(--cyber-cyan)',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1039b119c-1772163746686.png",
  imageAlt: 'Dark terminal screen with glowing blue code and network topology visualization',
  github: '#',
  live: '#'
},
{
  id: 'PRJ-004',
  name: 'Project 4',
  tagline: 'LOREM IPSUM DOLOR SIT AMET',
  description:
  'LOREM IPSUM DOLOR SIT AMET, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  type: 'SYSTEMS',
  status: 'DEPLOYED',
  statusColor: 'var(--cyber-green)',
  tech: ['Tech1', 'Tech2', 'Tech5', 'Tech3', 'Tech4'],
  metrics: [
  { label: 'LATENCY', value: '<10ms' },
  { label: 'JOBS/SEC', value: '50k+' },
  { label: 'UPTIME', value: '99.98%' }],

  accentColor: 'var(--cyber-cyan)',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1039b119c-1772163746686.png",
  imageAlt: 'Dark terminal screen with glowing blue code and network topology visualization',
  github: '#',
  live: '#'
}];


export default function ProjectsSection() {
  const [activeProject, setActiveProject] = useState<string | null>(null);

  return (
    <section
      id="projects"
      className="relative py-24 px-6 md:px-12 overflow-hidden"
      style={{ background: 'var(--cyber-black)' }}
      aria-label="Projects section">
      
      {/* Top border */}
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, var(--cyber-magenta), transparent)' }} />
      

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="font-mono text-xs mb-3" style={{ color: 'var(--cyber-cyan)', letterSpacing: '0.3em' }}>
              // MODULE:02 
            </p>
            <h2 className="font-mono font-black text-4xl md:text-6xl" style={{ color: '#FFFFFF', letterSpacing: '-0.02em' }}>
              PROJECT<span className="text-glow-magenta">_LOG</span>
            </h2>
          </div>
          <div
            className="font-mono text-xs px-4 py-2 self-start"
            style={{
              background: 'rgba(255,0,110,0.06)',
              border: '1px solid rgba(255,0,110,0.2)',
              color: 'var(--cyber-magenta)',
              letterSpacing: '0.15em',
              clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))'
            }}>
            
            {PROJECTS.length} ENTRIES // CLICK_TO_EXPAND
          </div>
        </div>

        {/* Project grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {PROJECTS.map((project) => {
            const isActive = activeProject === project.id;

            return (
              <div
                key={project.id}
                className="project-card cyber-panel cursor-pointer group"
                style={{
                  border: `1px solid ${isActive ? project.accentColor + '60' : 'rgba(0,212,255,0.1)'}`,
                  boxShadow: isActive ?
                  `0 0 20px ${project.accentColor}20, 0 0 60px ${project.accentColor}08` :
                  'none'
                }}
                onClick={() => setActiveProject(isActive ? null : project.id)}
                role="button"
                tabIndex={0}
                aria-expanded={isActive}
                onKeyDown={(e) => e.key === 'Enter' && setActiveProject(isActive ? null : project.id)}>
                
                {/* Project image */}
                <div className="relative h-48 overflow-hidden">
                  <AppImage
                    src={project.image}
                    alt={project.imageAlt}
                    fill
                    className="object-cover transition-transform duration-700 group-hover:scale-105" />
                  
                  {/* Overlay */}
                  <div
                    className="absolute inset-0"
                    style={{
                      background: `linear-gradient(180deg, ${project.accentColor}10 0%, rgba(3,5,7,0.85) 100%)`
                    }} />
                  
                  {/* HUD overlay on hover */}
                  <div
                    className="card-overlay absolute inset-0 flex items-center justify-center"
                    style={{ background: 'rgba(3,5,7,0.5)' }}>
                    
                    <div
                      className="font-mono text-xs px-4 py-2"
                      style={{
                        border: `1px solid ${project.accentColor}`,
                        color: project.accentColor,
                        background: 'rgba(3,5,7,0.8)',
                        letterSpacing: '0.2em'
                      }}>
                      
                      {isActive ? 'COLLAPSE_MODULE' : 'EXPAND_MODULE'}
                    </div>
                  </div>
                  {/* Top-right ID tag */}
                  <div
                    className="absolute top-3 right-3 font-mono text-[9px] px-2 py-0.5"
                    style={{
                      background: 'rgba(3,5,7,0.8)',
                      border: `1px solid ${project.accentColor}40`,
                      color: project.accentColor,
                      letterSpacing: '0.2em'
                    }}>
                    
                    {project.id}
                  </div>
                  {/* Status badge */}
                  <div
                    className="absolute top-3 left-3 flex items-center gap-1.5 font-mono text-[9px] px-2 py-0.5"
                    style={{
                      background: 'rgba(3,5,7,0.8)',
                      border: `1px solid ${project.statusColor}40`,
                      color: project.statusColor,
                      letterSpacing: '0.15em'
                    }}>
                    
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: project.statusColor }} />
                    {project.status}
                  </div>
                </div>

                {/* Card body */}
                <div className="p-6">
                  <div className="flex items-start justify-between gap-4 mb-3">
                    <div>
                      <div className="font-mono text-[9px] mb-1" style={{ color: project.accentColor, letterSpacing: '0.2em' }}>
                        TYPE: {project.type}
                      </div>
                      <h3
                        className="font-mono font-black text-xl"
                        style={{ color: '#FFFFFF', letterSpacing: '-0.02em' }}>
                        
                        {project.name}
                      </h3>
                      <p className="font-mono text-xs mt-1" style={{ color: 'rgba(200,216,232,0.6)' }}>
                        {project.tagline}
                      </p>
                    </div>
                  </div>

                  {/* Metrics row */}
                  <div className="flex gap-4 mb-4">
                    {project.metrics.map((m) =>
                    <div key={m.label}>
                        <div className="font-mono font-bold text-sm" style={{ color: project.accentColor }}>
                          {m.value}
                        </div>
                        <div className="font-mono text-[9px]" style={{ color: 'rgba(200,216,232,0.4)', letterSpacing: '0.1em' }}>
                          {m.label}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Tech badges */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tech.map((t) =>
                    <span
                      key={t}
                      className="font-mono text-[9px] px-2 py-0.5"
                      style={{
                        background: `${project.accentColor}0A`,
                        border: `1px solid ${project.accentColor}25`,
                        color: 'rgba(200,216,232,0.6)',
                        letterSpacing: '0.1em'
                      }}>
                      
                        {t}
                      </span>
                    )}
                  </div>

                  {/* Expanded description */}
                  <div
                    className="overflow-hidden transition-all duration-500"
                    style={{ maxHeight: isActive ? '200px' : '0px' }}>
                    
                    <p
                      className="font-mono text-xs leading-relaxed mb-4"
                      style={{ color: 'rgba(200,216,232,0.65)', borderTop: `1px solid ${project.accentColor}20`, paddingTop: '16px' }}>
                      
                      {project.description}
                    </p>
                    <div className="flex gap-3">
                      <a
                        href={project.github}
                        onClick={(e) => e.stopPropagation()}
                        className="cyber-btn cyber-btn-outline flex items-center gap-2 px-4 py-2 font-mono text-xs"
                        style={{ borderColor: project.accentColor, color: project.accentColor }}
                        aria-label={`View ${project.name} on GitHub`}>
                        
                        <Icon name="CodeBracketIcon" size={14} />
                        GITHUB
                      </a>
                      <a
                        href={project.live}
                        onClick={(e) => e.stopPropagation()}
                        className="cyber-btn cyber-btn-primary flex items-center gap-2 px-4 py-2 font-mono text-xs"
                        style={{ background: project.accentColor, color: 'var(--cyber-black)' }}
                        aria-label={`View live demo of ${project.name}`}>
                        
                        <Icon name="ArrowTopRightOnSquareIcon" size={14} />
                        LIVE_DEMO
                      </a>
                    </div>
                  </div>
                </div>
              </div>);

          })}
        </div>

        {/* View all CTA */}
        <div className="mt-10 text-center">
          <a
            href="#"
            className="cyber-btn cyber-btn-outline inline-flex items-center gap-3 px-8 py-3 font-mono text-sm"
            aria-label="View all projects">
            
            <Icon name="FolderOpenIcon" size={18} />
            LOAD_ALL_PROJECTS
          </a>
        </div>
      </div>
    </section>);

}